// Action types
const SET_USER = 'auth/SET_USER';
const SET_SESSION = 'auth/SET_SESSION';
const CLEAR_AUTH = 'auth/CLEAR_AUTH';
const SET_AUTH_LOADING = 'auth/SET_AUTH_LOADING';
const SET_CREDITS = 'auth/SET_CREDITS';
const SET_IS_ADMIN = 'auth/SET_IS_ADMIN';

// Action creators
export const setUser = (user) => ({ type: SET_USER, payload: user });
export const setSession = (session) => ({ type: SET_SESSION, payload: session });
export const clearAuth = () => ({ type: CLEAR_AUTH });
export const setAuthLoading = (loading) => ({ type: SET_AUTH_LOADING, payload: loading });
export const setCredits = (n) => ({ type: SET_CREDITS, payload: n });
export const setIsAdmin = (v) => ({ type: SET_IS_ADMIN, payload: v });

const initialState = {
  user: null,
  session: null,
  loading: true,
  credits: null, // null = not yet loaded; 0 = loaded, no credits; N = N credits remaining
  isAdmin: false,
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case SET_USER:
      return { ...state, user: action.payload };
    case SET_SESSION:
      return { ...state, session: action.payload };
    case CLEAR_AUTH:
      return { user: null, session: null, loading: false, credits: null, isAdmin: false };
    case SET_AUTH_LOADING:
      return { ...state, loading: action.payload };
    case SET_CREDITS:
      return { ...state, credits: action.payload };
    case SET_IS_ADMIN:
      return { ...state, isAdmin: action.payload };
    default:
      return state;
  }
}
